"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashTxBytes = void 0;
var SHA256_1 = require("jscrypto/SHA256");
var Base64_1 = require("jscrypto/Base64");
/*
DEPRECATED (was used by crypto-js)
function byteArrayToWordArray(ba: Uint8Array): CryptoJS.LibWordArray {
  const wa: number[] = [];
  for (let i = 0; i < ba.length; i += 1) {
    wa[(i / 4) | 0] |= ba[i] << (24 - 8 * i);
  }
  return crypto.lib.WordArray.create(wa);
}*/
/**
 * Calculates the transaction hash from Proto-encoded string.
 * @param txData Proto-encoded string (base64)
 */
function hashTxBytes(txData) {
    return SHA256_1.SHA256.hash(Base64_1.Base64.parse(txData)).toString().toUpperCase();
}
exports.hashTxBytes = hashTxBytes;
//# sourceMappingURL=hash.js.map